import IncrementMarquee from "./incrementMarquee";
export default IncrementMarquee;